import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  backToSearchResults: {
    id: 'location.hero.backToSearchResults',
    description: 'mloc hero btn - back to search results',
    defaultMessage: 'Back to search results'
  },
  startNewSearch: {
    id: 'location.hero.startNewSearch',
    description: 'mloc hero btn - start a new search',
    defaultMessage: 'Start a new search'
  },
  ariaCloseDrawerLabel: {
    id: 'provider_drawer.aria.label.close_drawer',
    description: 'Aria label text for close drawer',
    defaultMessage: 'Close Provider Drawer'
  }
});
